<script>

import { fetch_top_projects, get_page_guid } from './api';

export let site_root;

let guid = get_page_guid();
let top_projects = fetch_top_projects(site_root);

let HEIGHT = 293;

let prev_y = 0;
let y = 0;
let diff = 0;
let bottom = -HEIGHT;
let active = true;


$: if (prev_y !== y) {
    diff = y - prev_y;
	prev_y = y;

	bottom = Math.min(0, Math.max(-HEIGHT, bottom - diff))
} else {
	diff = 0;
}


</script>
<svelte:window bind:scrollY={y} />


{#await top_projects}
{:then items}
{#if items && items.length}
<div class="top-projects-banner-svelte" id="the-only-top-projects-banner-svelte" class:active={active} style="--bottom: {bottom}px;" bind:clientHeight={HEIGHT}>
	{#each items as item, i}
		<a class="{`item item-${i}`}" href="{item.full_url}?src=top_projects_banner&from={guid}" target="_blank">
			<img src={item.image_url} alt={item.title}>
			<span class="item-title">
				{item.title}
			</span>
		</a>
	{/each}

	<button class="close-btn" on:click="{() => active = false}">×</button>
</div>
{/if}
{:catch error}
{/await}

<style lang="scss">
@import './mixins.scss';

$bg-color: white;
$font-color: #777;

#the-only-top-projects-banner-svelte {
	all: initial;
	font-family: ProximaNova, ProximaNovaFallback, sans-serif;

	* {
		all: unset;
		font-family: ProximaNova, ProximaNovaFallback, sans-serif;
	}

	position: fixed;
	bottom: var(--bottom);
	width: 100%;
	background-color: $bg-color;
	border-top: 1px solid #ccc;
	color: $font-color;

	* {
		color: $font-color;
	}

	display: none;
	&.active {
		display: flex;
	}

	justify-content: center;

	.item {
		display: flex;
		flex-direction: row;
		border: 2px solid $bg-color;
		margin: 0 1em;
		padding: 0.5em;
		flex: 1 1 0px;
		max-width: 30em;
		color: $font-color;
		cursor: pointer;

		img {
			max-width: 5em;
            max-height: 3em;
            object-fit: cover;
            object-position: top;
			margin-right: 0.5em;
		}

		a {
			text-decoration: none;
			border: none
		}

		&:hover {
			// border-color: white;
			border: 2px dotted $font-color;
		}
	}

	.close-btn {
		display: block;
		border: none;
		background: none;
		font-size: 5em;
		color: white;
		position: absolute;
		top: 0;
		right: 0;
		font-family: ProximaNova, ProximaNovaFallback, sans-serif;
	    line-height: 0.6;
		cursor: pointer;
		&:hover {
			color: black;
		}
		font-weight: 100;
	}


	@media screen and (max-width: 800px) {
		.item {
			display: block;

			img {
				float: left;
			}
		}

		.item-2 {
			display: none !important;
		}	
	}

	@media screen and (max-width: 620px) {
		display: none !important;
	}
}
</style>